export default __webpack_public_path__ + "static/Flutterimage-1b69908e7ed709783282211290872980.jpg";